import { Injectable } from '@angular/core';
import { PlessHttp } from 'src/app/shared/http/pless-http.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonUploadServiceSub } from 'src/app/commons/kymw00/pless-json-upload-sub.service';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';
import { KYMW1100Model } from '../kymw1100.model';

// レスポンス構造
export interface CreateEBaseDataResponse {
  /** eBASE商品情報一覧 */
  EbaseListGoodsInfo: {
    /** eBASE仕様書No */
    CaEbaseSpecCode: string;
    /** 商品名 */
    GuideGoodsName: string;
    /** 規格名 */
    GuideStandardName: string;
    /** JANコード */
    JanCode: string;
    /** 確定入数 */
    FixContainNum: string;
    /** メーカー名 */
    MakerName: string;
    /** 連携先Pコード */
    LinkedPcode: string;
    /** 連携先アイテムコード */
    LinkedItemCode: string;
    /** 処理判定フラグ (0:新規登録, 1:更新, 2:取込先選択) */
    ProcessFlag: string;
  }[];
}

/** eBASE 取込商品候補一覧取得 サービス */
@Injectable({
  providedIn: 'root'
})
export class CreateEBaseDataService extends PlessJsonUploadServiceSub<CreateEBaseDataResponse> {
  model: KYMW1100Model;
  private successFunc: (response: CreateEBaseDataResponse) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @returns {PlessRequest} リクエストJSON
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model KYMW1100Model
   * @param file アップロードされたeBASE取込ファイル
   * @param successFunc 成功時処理
   * @memberof CreateEBaseDataService
   */
  execute(model: KYMW1100Model, file: File, func?: (response: CreateEBaseDataResponse) => void): void {
    this.model = model;
    if (func) {
      this.successFunc = func;
    }
    this.sendFile('createEBaseData', this.getBody(), file);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CreateEBaseDataService
   */
  success(data: CreateEBaseDataResponse) {
    if (this.successFunc) {
      this.successFunc(data);
    }
  }

}
